import { render } from "./Finished.vue?vue&type=template&id=fb85013e&scoped=true"
import script from "./Finished.vue?vue&type=script&lang=js"
export * from "./Finished.vue?vue&type=script&lang=js"

import "./Finished.vue?vue&type=style&index=0&id=fb85013e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb85013e"]])

export default __exports__